export const points = [
  {
    name: "Up to 3x Allo Points from [usd.ai](https://usd.ai) pro-rata based on allocation.",
    logo: "/points/allo.png",
    collateralVaults: [
      "0x8Aec278c2fD4cc07B10A8865AEd33775f93EACe6",
      "0xa9C251F8304b1B3Fc2b9e8fcae78D94Eff82Ac66",
      "0x9c46EE1f01d2b551048F5fF99a4659D98d04BED1",
      "0xe818ad0D20D504C55601b9d5e0E137314414dec4",
    ],
  },
  {
    name: "3x Allo Points from [usd.ai](https://usd.ai)",
    logo: "/points/allo.png",
    collateralVaults: [
      "0x98d6863fa1C247d529c94e53f521897ae9A6EBf0",
      "0x141A6f77ca186861BFB323b07012e80Ef4e09041",
      "0x66Ab62571Ccd31D911EeEfea85944895e30c0A3a",
    ],
  },
  {
    name: "2x Allo Points from [usd.ai](https://usd.ai)",
    logo: "/points/allo.png",
    collateralVaults: ["0x767d33217e7d2670695FfE2a104548B780f4F5d8"],
  },
  {
    name: "5x Allo Points from [usd.ai](https://usd.ai)",
    logo: "/points/allo.png",
    collateralVaults: ["0xAADEA03f6D6F198Bdc9229bD8113aceD19031773"],
  },
  {
    name: "20x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: [
      "0xbd2D9A3c34f866387a371035dc94Cbe94759E6d8",
      "0x2beBDc03D4268247c205ECB6926332221EC612AC",
      "0x0a39a99f1639a9e26ED9F7c096165A41FDEb5E63",
      "0x1b44853e7C3b6acBA72C0B05e08B1F6aa029ff15",
      "0x9CbADf620185f98dd61241242089Ff5f960aDcB8",
    ],
  },
  {
    name: "5x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: [
      "0xAc40D41aB11b0eb991a7D34D55DbDbB7849e92EF",
      "0x538f01e0BA3cf3aB5b3837A0d138a3F67b9b8235",
      "0x4718484ac9dc07fbbC078561e8f8Ef29e2a369CD",
      "0xb23377af59d4fC95cB8330eE2834Aa8241EEed03",
      "0x6A9E59545169BE88115671D7171967F8FbFfA0CD",
      "0x9c46EE1f01d2b551048F5fF99a4659D98d04BED1",
    ],
  },
  {
    name: "5x Resolv Points pro-rata based on allocation.",
    logo: "/points/resolv.svg",
    collateralVaults: [
      "0xe818ad0D20D504C55601b9d5e0E137314414dec4",
      "0xa5EeD1615cd883dD6883ca3a385F525e3bEB4E79",
      "0xa9C251F8304b1B3Fc2b9e8fcae78D94Eff82Ac66",
    ],
  },
  {
    name: "10x Elixir Potions",
    logo: "/points/potions.png",
    collateralVaults: [
      "0x5EFb3B2899a76e013040E85438cbe308870f5F50",
      "0xD59f6112375D60e45C2BA9dd5745870c1444362F",
      "0x3799251bD81925cfcCF2992F10Af27A4e62Bf3F7",
    ],
  },
  {
    name: "8x Juice",
    logo: "/points/yuzu-juice.svg",
    collateralVaults: ["0xDa33Ba72A303C26515edE275a2521b469F97D71b"],
  },
  {
    name: "1x Juice",
    logo: "/points/yuzu-juice.svg",
    collateralVaults: [
      "0x2F33b4AE409e86c6BEa9E2Bbe98361c19F2A1f0c",
      "0xfc5c4e5593A352CEDc9E5D7fD4e21b321140c345",
    ],
  },
  {
    name: "6x Juice",
    logo: "/points/yuzu-juice.svg",
    collateralVaults: [
      "0x9d86B4fc23D8438fC4Aba58642DC35D5F64fE941",
      "0xFE8d21E64e0c6CFb9abF224e805452acdE8e91Fa",
    ],
  },
] as const
